import { AccountType, IContactDetailsResponse } from "@miplatform/types";
import {
  useAccounts,
  useCommunities,
  useContacts,
  useDepartments,
  useSeries,
  useSeriesGroup,
} from "@mibuildweb/hooks";

export const useRequestDetailsSectionViewModel = () => {
  const { accounts, getAccounts } = useAccounts({
    accountTypes: [AccountType.Builder],
  });
  const { seriesGroups, getSeriesGroups } = useSeriesGroup();
  const { series, getSeries } = useSeries();
  const { communities, getCommunities } = useCommunities();
  const { contacts, setContacts, getContacts } = useContacts();
  const { departments, getDepartments } = useDepartments();

  const addContact = (contact: IContactDetailsResponse) => {
    setContacts((prev) => [...prev, contact]);
  };

  const getAllData = async () => {
    await Promise.all([
      getCommunities(),
      getAccounts(),
      getContacts({ filters: { status: "Active" } }),
      getDepartments({ filters: { name: "Estimating" } }),
    ]);
  };

  const fetchContacts = async (builderId: string) => {
    getContacts({
      filters: {
        status: "Active",
        accountId: { type: "guid", value: builderId },
      },
    });
  };

  const fetchSeriesGroups = async (builderId: string) => {
    getSeriesGroups({
      filters: { accountId: { type: "guid", value: builderId } },
    });
  };

  const fetchSeries = async (builderId: string, seriesGroupId?: string) => {
    const seriesGroupIdFilter = seriesGroupId
      ? { type: "guid", value: seriesGroupId }
      : { type: "guid", value: null };

    getSeries({
      filters: {
        accountId: { type: "guid", value: builderId },
        seriesGroupId: seriesGroupIdFilter,
      },
    });
  };

  return {
    accounts,
    seriesGroups,
    series,
    communities,
    contacts,
    departments,
    getAllData,
    fetchContacts,
    fetchSeriesGroups,
    fetchSeries,
    addContact,
  };
};
